export const nav = {
    items: [
        {
            name: 'Domains',
            url: '/admin/domains',
            icon: 'fa fa-globe',
            class: 'm-20[px]',
        },
        {
            name: 'Settings',
            url: '/admin/settings',
            icon: 'fa fa-cogs',
            class: 'm-20[px]',
        },
        {
            name: 'Users',
            url: '/admin/users',
            icon: 'fa fa-user',
            class: 'm-20[px]',
        },
    ],
};

export const mobileNav = {
    items: [
        {
            name: 'Domains',
            url: '/admin/domains',
            icon: 'fa fa-globe',
        },
        {
            name: 'Settings',
            url: '/admin/settings',
            icon: 'fa fa-cogs',
        },
        {
            name: 'Users',
            url: '/admin/users',
            icon: 'fa fa-user',
            class: 'm-20[px]',
        },
    ],
};
